import { FlowPage } from 'src/lib/flow/FlowPage';
import { isEligibleForLongboardingExperiment } from 'src/lib/flow/pageHelpers';

const isEnabled: FlowPage['isEnabled'] = (context) => {
  return (
    isEligibleForLongboardingExperiment(context) &&
    context.experimentFlags.longboarding == 'treatment'
  );
};

const longboardingFlooringPage: FlowPage = {
  slug: () => 'flooring',
  title: () => 'What are the main types of flooring in your home?',
  isEnabled,
  autoAdvance: () => true,
  subtitle: () => 'Choose what’s most common in your home. You can select up to two.',
  questions: () => [
    {
      key: 'home.flooring',
      type: 'multi_select',
      options: [
        {
          label: 'Carpet',
          value: 'carpet',
        },
        {
          label: 'Tile',
          value: 'tile',
        },
        {
          label: 'Laminate',
          value: 'laminate',
        },
        {
          label: 'Hardwood',
          value: 'hardwood',
        },
        {
          label: 'Linoleum',
          value: 'linoleum',
        },
        {
          label: 'Vinyl',
          value: 'vinyl',
        },
        {
          label: 'Other',
          value: 'other',
        },
      ],
    },
  ],
};

export default longboardingFlooringPage;
